// extracted by mini-css-extract-plugin
export var cardLayout = "_9q-1";
export var paginationContainer = "_9q-0";